module.exports = __webpack_public_path__ + "static/media/check_environnement.d5320b84.png";